/**
 * PdfDownload — a download affordance for a PDF (Lingua Franca, pricing PDF,
 * whitepapers). Composes the Button primitive (asChild → <a>) + a file icon
 * and a human-readable size. No bespoke CSS.
 */
import { Download } from 'lucide-react';
import { Button } from '../button';
import { formatFileSize } from '../../utils';

export interface PdfDownloadProps {
  readonly href: string;
  readonly label: string;
  /** File size in bytes — rendered as a human-readable hint after the label. */
  readonly sizeBytes?: number;
}

export function PdfDownload({ href, label, sizeBytes }: PdfDownloadProps) {
  return (
    <div className="my-8">
      <Button asChild variant="outline" size="lg">
        <a href={href} download target="_blank" rel="noopener noreferrer">
          <Download aria-hidden="true" />
          <span>{label}</span>
          {typeof sizeBytes === 'number' && (
            <span className="text-muted-foreground">· PDF, {formatFileSize(sizeBytes)}</span>
          )}
        </a>
      </Button>
    </div>
  );
}
